import { BrowserRouter as Router } from "react-router-dom";
import { GoogleMapsProvider } from "./context/GoogleMapsContext";
import { PrivacyProvider } from "./context/PrivacyContext";
import AppContent from "./AppContent"; // move routes to a new file

function App() {
  return (
    <Router>
      <PrivacyProvider>
        <GoogleMapsProvider>
          <AppContent />
        </GoogleMapsProvider>
      </PrivacyProvider>
    </Router>
  );
}

export default App;
